import { waitLoad } from '../utilities/load'

export class ParallaxHeader {
    constructor(params = {}) {

        waitLoad().then(()=>{
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const lighthouse = urlParams.get('lighthouse')
            if(!lighthouse){
                this.init();
            }
        })
    }
    init() {
        const windowWidth = window.innerWidth;
        const headerHero = document.querySelector('.page-item--fixed');
        const mainHeader = document.querySelector('.single-banner__block');
        if(headerHero && mainHeader) {
            if(windowWidth < 1200) {
                var rellax = new Rellax('.parallax-anchor', {
                    speed: 5,
                });
                var rellax = new Rellax('.page-item .parallax-anchor__point', {
                    speed: -5,
                });
            } else {
                var rellax = new Rellax('.parallax-anchor');
                var rellax = new Rellax('.page-item .parallax-anchor__point');
            }

            const headerHeroHeight = mainHeader.clientHeight;
            headerHero.style.height = headerHeroHeight + 20 +'px';
            window.setTimeout(()=>{
                this.resetContentRightAlignment();
            })
            window.onresize = () => {
                this.onResize();
            }
            window.onscroll = () => {
                this.onScroll();
            }
        }
    }
    resetContentRightAlignment() {
        if(document !== null){
            const mainHeader = document.querySelector('.page-item--fixed')
            const mainHeaderContent = mainHeader.querySelector('.standalone-content__item')
            setTimeout( () => {
                if(window.innerWidth > 1220) {
                    mainHeaderContent.style.left = 'unset';
                    let marginElement = document.querySelector('.site-header__nav');
                    const style = marginElement.currentStyle || window.getComputedStyle(marginElement);
                    mainHeaderContent.style.right = parseFloat(style.marginRight.split('px')[0]) + parseFloat(style.paddingRight.split('px')[0]) + 'px';
                } else {
                    mainHeaderContent.style.left = '';
                    mainHeaderContent.style.right = '';
                }
            }, 10)
        }
    }
    onResize() {
        const headerHero = document.querySelector('.page-item--fixed');
        const mainHeader = document.querySelector('.parallax-anchor');
        if(headerHero && mainHeader) {
            const headerHeroHeight = mainHeader.clientHeight;
            headerHero.style.height = headerHeroHeight + 20 + 'px';
        }
        this.resetContentRightAlignment();
    }
    onScroll() {
        const parallaxDiv = document.querySelector('.page-item--not-fixed');
        const parallaxDivFixed = document.querySelector('.page-item--fixed');
        const fadeOutDiv =  document.querySelector('.is-below-md');
        const distanceToTop = parallaxDiv.getBoundingClientRect().top;
        const windowWidth = window.innerWidth;
        if(parallaxDivFixed) {
            const math = (window.scrollY * 100) / parallaxDivFixed.clientHeight;
            const test = (100 - math) / 100;

            if(windowWidth <= 700){
                fadeOutDiv.style.opacity = test.toFixed(2).toString();
            }
        }
    }
};
